import React from 'react';
import { useNavigate } from 'react-router-dom';
import './JournalNavigation.css';

const JournalNavigation = ({ prevPage, nextPage }) => {
    const navigate = useNavigate();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth'
        });
    };

    const handlePrev = () => {
        if (prevPage) {
            navigate(prevPage);
            // Small delay to ensure navigation completes before scrolling
            setTimeout(scrollToTop, 100);
        }
    };

    const handleNext = () => {
        if (nextPage) {
            navigate(nextPage);
            // Small delay to ensure navigation completes before scrolling
            setTimeout(scrollToTop, 100);
        }
    };

    return (
        <div className="journal-navigation">
            <button
                className="journal-nav-btn prev-btn"
                onClick={handlePrev}
                disabled={!prevPage}
            >
                <span className="nav-icon">←</span>
                <span className="nav-text">Previous</span>
            </button>

            <button
                className="journal-nav-btn next-btn"
                onClick={handleNext}
                disabled={!nextPage}
            >
                <span className="nav-text">Next</span>
                <span className="nav-icon">→</span>
            </button>
        </div>
    );
};

export default JournalNavigation;
